import React, { useEffect, useState } from 'react';
import search from '../../../assets/image/search-status.svg';
import trashIcon from '../../../assets/image/delete.svg';
import importantIcon from '../../../assets/image/important-icon.svg';
import importantIconColor from '../../../assets/image/important_icon_color.svg';
import favIcon from '../../../assets/image/fav-icon.svg';
import favIconColor from '../../../assets/image/fav_icon_color.svg';
import Button from '../../../component/ui/Button';
import './notification.scss';
import Modal from '../../../component/modal/Modal';
import { getNotifications, updateStatusNotification } from '../../../services/dashboard';
import { format } from 'date-fns';
import Pagination from '../../../component/pagination';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
	initializeNotifications,
	updateRecentNotifications,
} from '../../../store/action/notifications';
import { getExpiryText } from '../../../utils/dateUtils';

const NotificationPage = () => {
	const dispatch = useDispatch();
	const {
		notification: notificationsList,
		total_unread_counts: unreadCount,
		total_pages: totalPages,
	} = useSelector((state) => state.notifications);
	const [activeTab, setActiveTab] = useState('All');
	const [isOpenModal, setIsOpenModal] = useState(false);
	const [bulkAction, setBulkAction] = useState([]);
	const [modelData, setModelData] = useState({});
	const [isLoading, setLoading] = useState(false);
	const navigate = useNavigate();
	const params = useParams();
	const [notificationParams, setNotificationParams] = useState({
		page: 1,
		page_size: 20,
		sort_by: 'desc',
		order_by: 'created_at',
		search: '',
		is_archived: false,
	});

	const formatDateTime = (isoString) => {
		return format(new Date(isoString), 'dd/MM/yyyy  hh:mm a');
	};

	const handleActionClick = (action) => {
		const id = action.includes('product-create') ? action.split('product-create/')[1] : null;
		if (id) {
			// var data = `productId=${id}`;
			navigate(`/user/${params.suburl}/purchases-order-create/product_id=${id}`);
		} else if (!action.includes('undefined')) {
			navigate(`/user/${params.suburl}/${action}`);
		}
	};

	const markReadNotification = async (ids = []) => {
		try {
			var body = {};
			if (bulkAction.length > 0 || ids.length > 0) {
				body = {
					status: 'is_read',
					value: true,
					ids: ids.length > 0 ? ids : bulkAction,
					mark_as_read: false,
				};
			} else {
				body = {
					status: 'is_read',
					value: true,
					mark_all_read: true,
				};
			}
			var idsList = [];
			if (bulkAction.length === 0 && ids.length === 0) {
				idsList = notificationsList.filter((data) => data.is_read === false).map((item) => item.id);
			}

			console.log(idsList);

			await updateStatusNotification(body);
			dispatch(updateRecentNotifications({ ids: ids.length > 0 ? ids : idsList }));
			setBulkAction([]);
			getNotificationList();
		} catch (error) {
			console.log(error);
			toast.error(error.response.message || 'Somenthing went wrong');
		}
	};

	async function updateNotificationStatus(status, value, ids) {
		try {
			var body = {
				status: status,
				value: value,
				ids: ids,
			};
			await updateStatusNotification(body);
			getNotificationList();
		} catch (error) {
			toast.error(error.response.message || 'Somenthing went wrong');
		}
	}

	const handleCheckboxChange = () => {
		if (bulkAction.length !== notificationsList.length) {
			setBulkAction(notificationsList.map((n) => n.id));
		} else {
			setBulkAction([]);
		}
	};
	const handleSingleCheckBox = (id) => {
		if (bulkAction.includes(id)) {
			setBulkAction(bulkAction.filter((data) => data !== id));
		} else {
			setBulkAction([...bulkAction, id]);
		}
	};

	const getNotificationList = async () => {
		try {
			setLoading(true);
			var params = {};
			if (activeTab === 'Unread') {
				params = { ...notificationParams, is_read: false };
			} else if (activeTab === 'Favourite') {
				params = { ...notificationParams, is_favourite: true };
			} else if (activeTab === 'Important') {
				params = { ...notificationParams, is_important: true };
			} else if (activeTab === 'Archive') {
				params = { ...notificationParams, is_archived: true };
			} else {
				params = { ...notificationParams };
			}

			const { notifications, total_pages, total_unread_counts } = await getNotifications(params);

			dispatch(
				initializeNotifications({
					notifications: notifications,
					total_unread_counts: total_unread_counts,
					total_pages,
				}),
			);
		} catch (e) {
			toast.error(e.response.message || 'Somenthing went wrong');
		} finally {
			setLoading(false);
		}
	};

	const handlePageChange = (page) => {
		setNotificationParams((prev) => ({
			...prev,
			page,
		}));
	};

	useEffect(() => {
		getNotificationList();
	}, [activeTab, notificationParams]);

	return (
		<div>
			<div className="setup-container">
				<div
					className="bg-white rounded-3"
					style={{
						boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
						overflow: 'hidden',
					}}
				>
					{/* Header Tabs */}
					<div
						className="d-flex justify-content-between px-3 border-bottom"
						style={{ paddingTop: '12px', paddingBottom: '5px' }}
					>
						<div className="d-flex align-items-center gap-6">
							<div className="d-flex gap-3">
								<input
									type="checkbox"
									className="mx-3 my-3 cursor-pointer"
									name="checkbox"
									style={{ width: '19px', height: '19px' }}
									checked={
										bulkAction.length > 0 ? bulkAction.length === notificationsList.length : false
									}
									onChange={handleCheckboxChange}
								/>
								<ul className="nav mt-2">
									{['All', 'Unread', 'Favourite', 'Important', 'Archive'].map((item, index) => (
										<li
											key={index}
											className="nav-item"
										>
											<div
												className={`tab-link ${activeTab === item ? 'active' : ''} d-flex align-items-center`}
												onClick={() => {
													setActiveTab(item);
													setNotificationParams((prev) => ({
														...prev,
														page: 1,
													}));
												}}
											>
												{item}
												{item === 'All' || item === 'Unread' ? (
													<span className="rounded-pill bg-light text-dark ms-2 small-badge">
														{`${unreadCount} new`}
													</span>
												) : (
													<></>
												)}
											</div>
										</li>
									))}
								</ul>
							</div>
						</div>
						<div className="d-flex align-items-center gap-3">
							<div className="d-flex align-items-center bg-white border border-gray rounded-2 shadow-sm px-3 py-1">
								<img
									src={search}
									alt="search-icon"
									width="20"
									height="20"
									className="rounded-circle me-2"
								/>
								<input
									type="search"
									placeholder="Search"
									style={{ border: '0' }}
									onChange={(e) => {
										setNotificationParams((prev) => ({
											...prev,
											search: e.target.value,
										}));
									}}
									className="flex-1 bg-transparent outline-none border-0 border-0 shadow-none text-gray-700 placeholder-gray-400"
								/>
							</div>
							<Button
								type="button"
								button={bulkAction.length > 0 ? 'Mark As Read' : 'Mark All Read'}
								className={`btn-primary mt-0 fs-5 px-4 py-0`}
								onClick={() => {
									markReadNotification();
								}}
								disabled={false}
							/>
						</div>
					</div>

					{/* Notifications List */}
					<div
						className="space-y-3"
						style={{ paddingTop: '20px', paddingBottom: '25px' }}
					>
						{notificationsList.length > 0
							? notificationsList.map((n) => (
									<div
										key={n.id}
										className={`d-flex justify-content-between align-items-center px-3 py-2`}
									>
										<div
											className={`d-flex align-items-center rounded-2 py-2 ${!n?.is_read ? 'bg-blue-50' : 'bg-gray'}`}
											style={{
												width: activeTab === 'Archive' ? '95%' : '96%',
												backgroundColor: !n?.is_read ? '#DADDEC' : '#F6F6F9',
												boxShadow: '0 5px 8px 0 rgba(0, 0, 0, 0.10)',
											}}
										>
											<div className="d-flex">
												<input
													type="checkbox"
													className="m-3 cursor-pointer"
													name="checkbox"
													style={{ width: '19px', height: '19px' }}
													checked={bulkAction.includes(n.id)}
													onChange={() => handleSingleCheckBox(n.id)}
												/>
												<img
													src={n?.is_favourite ? favIconColor : favIcon}
													alt="fav-icon"
													width="21px"
													height="21px"
													className="rounded-circle my-3 mx-1 cursor-pointer"
													onClick={() =>
														updateNotificationStatus('is_favourite', !n?.is_favourite, [n.id])
													}
												/>
												<img
													src={n?.is_important ? importantIconColor : importantIcon}
													alt="important-icon"
													width="21px"
													height="21px"
													className="rounded-circle m-3 cursor-pointer"
													onClick={() =>
														updateNotificationStatus('is_important', !n?.is_important, [n.id])
													}
												/>
											</div>
											<div
												style={{ width: '20%', color: '#555B67' }}
												className="fw-semibold px-3 fs-5 cursor-pointer"
												onClick={() => {
													if (n.metadata) {
														setIsOpenModal(true);
														setModelData(n);
														if (!n.is_read) {
															markReadNotification([n.id]);
														}
													}
												}}
											>
												{n.title}
											</div>
											<div
												style={{ width: '60%', color: '#555B67' }}
												className={`${n?.is_read ? 'fw-light' : 'fw-semibold'} fs-5 px-3 cursor-pointer`}
												onClick={() => {
													if (n.metadata) {
														setIsOpenModal(true);
														setModelData(n);
														if (!n.is_read) {
															markReadNotification([n.id]);
														}
													}
												}}
											>
												{n.description}
											</div>
											<div
												className="px-5"
												style={{
													width: '230px',
													color: '#555B67',
													display: 'flex',
													flexDirection: 'column',
													alignItems: 'end',
													cursor: 'pointer',
												}}
												onClick={() => {
													if (n.metadata) {
														setIsOpenModal(true);
														setModelData(n);
														if (!n.is_read) {
															markReadNotification([n.id]);
														}
													}
												}}
											>
												<div className={`${n?.is_read ? 'fw-light' : 'fw-semibold'} fs-5`}>
													{formatDateTime(n?.created_at)}
												</div>
												{activeTab === 'Archive' && (
													<div
														className={`${n?.is_read ? 'fw-light' : 'fw-semibold'} text-danger fs-6`}
													>
														{getExpiryText(n?.archived_at)}
													</div>
												)}
											</div>
										</div>

										{activeTab === 'Archive' ? (
											<div
												className="fs-5 fw-semibold text-center cursor-pointer"
												style={{ color: '#fd0000ff' }}
												onClick={() => updateNotificationStatus('is_archived', false, [n.id])}
											>
												Restore
											</div>
										) : (
											<img
												src={trashIcon}
												alt="search-icon"
												width="25px"
												height="25px"
												className="rounded-circle m-2 cursor-pointer"
												onClick={() => updateNotificationStatus('is_archived', true, [n.id])}
											/>
										)}
									</div>
								))
							: isLoading && (
									<div
										className="d-flex justify-content-center align-items-center"
										style={{ height: '43vh', overflow: 'hidden' }}
									>
										<span
											className="Page_loader"
											role="status"
											aria-hidden="true"
										></span>
									</div>
								)}
						{notificationsList.length === 0 && !isLoading && (
							<p className="text-center text-gray-500 py-10">No Notification Found.</p>
						)}
					</div>
				</div>
			</div>
			<Pagination
				currentPage={notificationParams.page}
				totalPages={totalPages}
				onChangePage={handlePageChange}
			/>
			{isOpenModal && (
				<Modal
					className="notificationModel"
					title={`${modelData?.metadata?.action_text}`}
					isOpen={isOpenModal}
					onClose={() => {
						setIsOpenModal(false);
					}}
					cancelButton={() => {
						setIsOpenModal(false);
					}}
				>
					<div>
						<div className="fs-5 fw-light text-black py-2">
							{formatDateTime(modelData?.created_at)}
						</div>
						<div className="fs-5 fw-light text-black py-2">{modelData?.description}</div>
					</div>

					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'start',
							marginTop: '10px',
						}}
					>
						<Button
							type="button"
							button={`Go to ${modelData.metadata?.action_text}`}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => handleActionClick(modelData?.metadata?.action_url)}
						/>
					</div>
				</Modal>
			)}
		</div>
	);
};

export default NotificationPage;
